<template>
  <v-flex>
    <v-tabs v-model="tab" class="elevation-2">
      <v-tabs-slider></v-tabs-slider>

      <template v-for="tab in tabList">
        <v-tab>{{ tab.text }}</v-tab>

        <v-tab-item>
          <v-card flat tile>
            <v-card-text>
              <component :is="tab.component"></component>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </template>
    </v-tabs>
  </v-flex>
</template>



<script>
import { mapState, mapActions } from "vuex";

import SettlementsSummary from "@/components/Settlements/Summary";
import SettlementsAll from "@/components/Settlements/All";

export default {
  components: {
    SettlementsSummary,
    SettlementsAll
  },

  mixins: [],

  props: [],
  data() {
    return {
      tab: null,
      
      tabList: [
        {
          text: "結帳狀態總覽",
          component: "SettlementsSummary"
        },
        {
          text: "結帳紀錄",
          component: "SettlementsAll"
        }
      ]
    };
  },

  computed: {},
  watch: {},
  methods: {},

  mounted() {}
};
</script>

<style lang="scss" scoped>
</style>
